import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import CookieConsent from "@/components/CookieConsent";

export default function Layout() {
  return (
    <div className="App grain relative">
      <Navbar />
      <ScrollToTop />
      <main className="relative">
        <Outlet />
      </main>
      <Footer />
      <CookieConsent />
    </div>
  );
}
